module.exports = __webpack_public_path__ + "img/0Q3A0072_FoamcoreMatted.6ce8dcc8.jpg";